import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { DialogLoginComponent } from "../Dialogs/dialog.login/dialog.login.component";


@Injectable({
  providedIn: "root"
})
export class UserService {


  constructor(public dialog: MatDialog) {

  }

  showLogin({
    url,
    message
  }: { url?: string | undefined; message?: string } = {}) {
    if (this.isAuthenticated()) {
      return;
    } else {
      const dialogRef = this.dialog.open(DialogLoginComponent, {
        width: "400px",
        disableClose: true,
        backdropClass: "login-gradientPaddingTop",
        data: {
          email: localStorage.getItem("email"),
          password: "",
          rememberme: true,
          url: url,
          message: message
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        // this.services.init().then(() => {
        //   if (this.services.route.url == "/register") {
        //     if (url) this.services.route.navigate([""]);
        //   } else {
        //     if (url) this.services.route.navigate([url]);
        //   }
        // });
      });
    }
  }

  login(
    email: string,
    password: string,
    rememberme: boolean = true,
    returnUrl: string = ""
  ): Promise<string> {
    return new Promise<string>((rs, rj) => {

      if (rememberme) {
       // localStorage.setItem(getPrefixedLocalStorageName("email"), email);
      } else {
     //   localStorage.removeItem(getPrefixedLocalStorageName("email"));
      }

    //   this.oxClient
    //     .refreshToken(email, password)
    //     .then(r => {
    //       if (r.error && r.error !== "") {
    //         rj(r.error);
    //       } else {
    //         setAuthToken(r.token);

    //       }
    //     })
    //     .catch(e => {

    //       rj(e);
    //     });
    // });
  })
}

  logout() {

  }

  // resetPassword(email: string): Promise<IResponseBaseModel> {
  //   return this.oxClient.restePassword(email);
  // }

  // getEmailFromCode(code: string): Promise<string> {
  //   return this.oxClient.getEmailFromCode(code);
  // }

  // NewPassword(
  //   code: string,
  //   email: string,
  //   password: string
  // ): Promise<IResponseBaseModel> {
  //   return this.oxClient.NewPassword(code, email, password);
  // }

  // public wasAuthenticated: boolean = false;

  isAuthenticated() {
    return false;
    // if (this.wasAuthenticated) {
    //   return true;
    // } else {
    //   if (getIsAuthenticated()) {
    //     this.wasAuthenticated = true;
    //   }

    //   return getIsAuthenticated();
    // }
  }

}
